import theme from "@/styles/theme";
import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${theme.colors.brown.capivara};
  padding: 1rem;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TextContainer = styled.div`
  max-width: 80%;
`;

export const Text = styled.p`
  margin: 0;
  font-size: 0.9rem;
  text-align: justify;
  margin-right: 4vw;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  width: 100px;
`;
